// Sub-view rendered when `useValidateProvisioningToken` throws.
//
// Branches on HTTP status (set by the apiClient on the ApiError):
//   404 → "Link non valido"
//   410 → "Link scaduto o già utilizzato"
//   anything else → generic "riprova fra qualche minuto"
//
// The `error.code` (BE domain code) is intentionally ignored here:
// HTTP status is the stable contract, the code values can drift
// without breaking the page.

import { Banner } from '@ab-platform/ui/banner';
import { FocusedPageShell } from '@ab-platform/ui/focused-page-shell';
import { ApiError } from '@/lib/envelope';

export function ValidateErrorView({ error }: { error: unknown }): JSX.Element {
  const status = error instanceof ApiError ? error.status : 0;

  if (status === 404) {
    return (
      <FocusedPageShell title="Link non valido">
        <Banner tone="warning">
          Il link che hai aperto non corrisponde a una richiesta valida. Apri di
          nuovo l’email da Aurino Broker o contattaci se il problema persiste.
        </Banner>
      </FocusedPageShell>
    );
  }

  if (status === 410) {
    return (
      <FocusedPageShell title="Link scaduto o già utilizzato">
        <Banner tone="warning">
          Questo link non è più attivo. Richiedi un nuovo invito ad Aurino Broker
          per impostare la password.
        </Banner>
      </FocusedPageShell>
    );
  }

  return (
    <FocusedPageShell title="Imposta la password">
      <Banner tone="danger">
        Non siamo riusciti a verificare il link in questo momento. Riprova tra
        qualche minuto.
      </Banner>
    </FocusedPageShell>
  );
}
